import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { BloodGlucoseAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';
import { ActionAlertComponent } from '../../action-alert/action-alert.component';

interface BloodGlucoseActionFormGroup {
	bloodGlucose: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-blood-glucose-action-controls',
    templateUrl: './blood-glucose-action-controls.component.html',
    styleUrls: ['../../../common.scss', './blood-glucose-action-controls.component.scss'],
    imports: [CommonActionControlsComponent, UnitQuantityControl, ReactiveFormsModule, ActionFormComponent, ActionAlertComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodGlucoseActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: BloodGlucoseAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as BloodGlucoseAction;
	}

	@Input() form!: FormGroup<BloodGlucoseActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

    ngOnInit(): void {
		this.form.addControl('bloodGlucose', this.formBuilder.control(this.action?.bloodGlucose ?? null));
	}
}